import React from 'react';
import {useTranslation} from 'react-i18next';
import '../hibuButton/hibuButton.scss';
import './hibuTooltip.scss';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';
import {Placement} from 'react-bootstrap/Overlay';
import {OverlayTriggerRenderProps} from 'react-bootstrap/OverlayTrigger';

type TooltipProps = {
    tooltipKey?: string;
    tooltipLabel?: string;
    placement?: Placement;
    translate?: boolean;
    delay?: number | {show: number; hide: number};
    defaultShow?: boolean;
    children: React.ReactElement | ((props: OverlayTriggerRenderProps) => React.ReactNode);
};

export const HibuTooltip = React.memo(
    ({tooltipKey, tooltipLabel, placement, children, delay, translate = true, defaultShow = false}: TooltipProps) => {
        const {t} = useTranslation();
        return (
            <OverlayTrigger
                delay={delay || 0}
                placement={placement || 'top'}
                trigger={['hover', 'focus', 'click']}
                overlay={
                    <Tooltip className="hibu-tooltip" id={'tooltip-' + tooltipKey}>
                        {translate ? tooltipKey && t(tooltipKey) : tooltipKey}
                        {tooltipLabel || ''}
                    </Tooltip>
                }
                defaultShow={defaultShow}
            >
                {children}
            </OverlayTrigger>
        );
    }
);
